module.exports = __webpack_public_path__ + "static/media/ic_contact_info.9974f1a1.svg";